import React, { Component } from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'

class ApplicationLoading extends Component {
  render () {
    const topLoadingStyle = {
      textAlign: 'center',
      fontFamily: '"Lato","Helvetica","Arial","Helvetica","sans-serif"',
      color: 'white',
      top: '50%',
      left: '50%',
      position: 'fixed',
      marginTop: '-100px',
      marginLeft: '-200px',
      width: '400px'
    }

    return (
      <div style={topLoadingStyle} >
        <Dimmer inverted active inline='centered'>
          <div>
            <img style={{verticalAlign: 'middle'}} inline='centered' src='https://defu9f4k3otpo.cloudfront.net/logo.png' />
            <span style={{position: 'relative', color: '#10b3e6', fontSize: '2rem', top: '7px'}}>API Documentation</span>
          </div>
          <Loader inline='centered' size='large'>Loading</Loader>
        </Dimmer>
      </div>
    )
  }
}

export default ApplicationLoading



// WEBPACK FOOTER //
// ./src/components/ApplicationLoading.js